module.exports = __webpack_public_path__ + "img/yuki icon 1.067013c7.png";